import { handlePlayListTabClick } from "redux-share/actions";
import { useAppSelector } from "redux-share/hooks";
import { shallowEqual } from "react-redux";
import PlayListIcon from "../../icon-components/playlistIcon";

const PlayListTab = () => {
    const { playList } = useAppSelector(({ videoData: { playList } }) => ({ playList }), shallowEqual);

    return (
        <>
            <div
                className="pl-flex pl-whitespace-nowrap pl-items-center pl-gap-[14px] pl-rounded-[20px] pl-text-secondary-700 dark:pl-text-secondary-50 pl-bg-gray-100 dark:pl-bg-dark-3 pl-px-4 pl-py-[7px] pl-cursor-pointer"
                onClick={handlePlayListTabClick}
            >
                <PlayListIcon className="pl-w-4 pl-h-4 pl-fill-gray-800 dark:pl-fill-dark-6" />
                <p>{playList!.length > 1 ? ` لیست‌های پخش (${playList!.length})` : `نمایش لیست‌پخش "${playList![0].title}"`}</p>
            </div>
        </>
    );
};

export default PlayListTab;
